import React from "react";
import { Box, Typography, Grid, Link, IconButton } from "@mui/material";
import Colors from "../components/Colors";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Facebook, Instagram } from "@mui/icons-material";
import facebook from "../images/facebook.svg";
import instagram from "../images/instagram.svg";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: Colors.footerbg,
        color: Colors.Tidesfont,
        // py:3,
        // px: 2,
        mt: { md: 5, xs: 2 },
        width: "100%",
        maxWidth: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        paddingTop: "2.5%",
        paddingBottom: "2.5%",
      }}
    >
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{
          flexDirection: { xs: "column", md: "row" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        {/* Left Section */}
        <Grid item>
          <Typography
            variant="h6"
            sx={{ fontWeight: 500, fontSize: { md: "20px", xs: "12px" } }}
          >
            Privacy Policy
          </Typography>
        </Grid>

        {/* Center Section - Navigation */}
        <Grid item>
          <Typography
            variant="h6"
            sx={{ fontWeight: 500, fontSize: { md: "20px", xs: "12px" } }}
          >
            Terms of Service
          </Typography>
        </Grid>

        {/* Right Section */}
        <Grid item>
          <Typography
            variant="h6"
            sx={{ fontWeight: 500, fontSize: { md: "20px", xs: "12px" } }}
          >
            Contact Us
          </Typography>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap={"0px"}>
        <IconButton
          href="https://www.facebook.com/share/1E4zxGLjDN/"
          target="_blank"
          sx={{
            // background: "white",
            // padding: "4px",
            borderRadius: "8px",
            "&:hover": { background: "none" },
          }}
        >
          <FacebookIcon sx={{ fontSize: 40, color: Colors.Tidesfont }} />{" "}
          {/* Change color here */}
        </IconButton>

        <IconButton
          href="https://www.instagram.com/snoword_puzzle?utm_source=qr&igsh=ZDZiN2s1bHRocndj"
          target="_blank"
          sx={{
            // background: "white",
            // padding: "4px",
            borderRadius: "8px",
            "&:hover": { background: "none" },
          }}
        >
          <InstagramIcon sx={{ fontSize: 40, color: Colors.Tidesfont }} />{" "}
          {/* Official Instagram color */}
        </IconButton>
      </Box>

      {/* Bottom Copyright */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          paddingTop: "20px",
        }}
      >
        <CopyrightIcon
          sx={{ color: Colors.white, fontSize: "12px", lineHeight: "18px" }}
        ></CopyrightIcon>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "12px",
            lineHeight: "18px",
            fontWeight: "400",
            color: Colors.white,
          }}
        >
          2024-2026
        </Typography>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "12px",
            lineHeight: "18px",
            fontWeight: "400",
            color: Colors.white,
          }}
        >
          all rights reserved by
        </Typography>
        {/* <Link to="https://www.varsha-info.com/" target="_blank" rel="noopener noreferrer"
                    style={{
                        textDecoration: 'none', color: Colors.Tidesfont, fontFamily: "Roboto", fontSize: '12px', cursor:'pointer',
                        lineHeight: '18px', fontWeight: '400', transition: 'text-decoration 0.2s', textUnderlineOffset: "5px",
                    }}
                    onMouseEnter={(e) => { e.target.style.textDecoration = 'underline'; }}
                    onMouseLeave={(e) => { e.target.style.textDecoration = 'none'; }}>
                    www.varsha-info.com
                </Link> */}
        <a
          href="https://www.varsha-info.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: Colors.Tidesfont,
            fontFamily: "Roboto",
            fontSize: "12px",
            cursor: "pointer",
            lineHeight: "18px",
            fontWeight: "400",
            transition: "text-decoration 0.2s",
            textUnderlineOffset: "5px",
          }}
          onMouseEnter={(e) => {
            e.target.style.textDecoration = "underline";
          }}
          onMouseLeave={(e) => {
            e.target.style.textDecoration = "none";
          }}
        >
          www.varsha-info.com
        </a>
      </Box>
    </Box>
  );
};

export default Footer;
